import { render, staticRenderFns } from "./ProformCategoryTableMobile.vue?vue&type=template&id=d2ed7614&scoped=true"
import script from "./ProformCategoryTableMobile.vue?vue&type=script&lang=js"
export * from "./ProformCategoryTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ed7614",
  null
  
)

export default component.exports